import { render, staticRenderFns } from "./his-welfare.vue?vue&type=template&id=1f36124a&scoped=true"
import script from "./his-welfare.vue?vue&type=script&lang=js"
export * from "./his-welfare.vue?vue&type=script&lang=js"
import style0 from "./his-welfare.vue?vue&type=style&index=0&id=1f36124a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f36124a",
  null
  
)

export default component.exports